<template>
    <div>
        <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">

        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">

                <div class="col-xl-8 order-xl-1">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">Member Details</h3>
                                </div>
                            </div>
                        </div>
                        <template>
                                <h6 class="heading-small text-muted mb-4">User information</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="National ID"
                                                        readonly
                                                        :value="specificMember.data.id_no"
                                            />
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Email address"
                                                        readonly
                                                        :value="email"
                                            />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="First name"
                                                        readonly
                                                        :value="specificMember.data.member_firstname"
                                            />
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Last name"
                                                        readonly
                                                        :value="specificMember.data.member_lastname"
                                            />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Member Shares"
                                                        readonly
                                                        :value="specificMember.data.member_shares"
                                            />
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Gender"
                                                        readonly
                                                        :value="specificMember.data.gender"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <!-- Address -->
                                <h6 class="heading-small text-muted mb-4">Contact information</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Telephone"
                                                        readonly
                                                        :value="specificMember.data.telephone"
                                            />
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Address"
                                                        readonly
                                                        :value="specificMember.data.address"
                                            />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="Marital Status"
                                                        readonly
                                                        :value="specificMember.data.marital_status"
                                            />
                                        </div>
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="Dependents"
                                                        readonly
                                                        :value="specificMember.data.dependents"
                                            />
                                        </div>
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="Property Area"
                                                        readonly
                                                        :value="specificMember.data.property_area"
                                            />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Education"
                                                        readonly
                                                        :value="specificMember.data.education"
                                            />
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Self Employed"
                                                        readonly
                                                        :value="specificMember.data.self_employed"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                        </template>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  export default {
    name: 'user-profile',
    data() {
      return {
          email: localStorage.getItem('email')
      }
    },
      created() {
          this.authorizedUser(this.authorizeMemberOnly);
          const userPublicId = localStorage.getItem('pdis');
          this.$store.dispatch('viewspecificMember_function', userPublicId);
      }
  };
</script>
<style></style>
